// test2228
(2228 && 0);
